"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var isSubUrlOf_1 = __importDefault(require("./isSubUrlOf"));
/**
 * Expects an array of paths that are denylisted.
 *
 * @example
 *  isUrlDenylisted('/developer/builder', ['/developer/']);
 *  > true
 */
var isUrlDenylisted = function (url, denylistedRoutePrefixes) {
    return denylistedRoutePrefixes.some(function (path) { return isSubUrlOf_1.default(url, path); });
};
exports.default = isUrlDenylisted;
